import { Col, Row } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import videoEnd from '../../assets/images/videoEnd.png'
import videoStart from '../../assets/images/videoStart.png'
function VideoTitle(props) {
  let videolist = props.videolist
  let path=props.path
  let videodom = videolist.map((item, index) => {
    if (props.viewid.indexOf(item.id) !== -1) {
      return (
        <Row key={index} style={{ margin: '1rem auto' }}>
        <Col span={15}>
          <img src={videoEnd} alt="end" style={{ width: '1rem' }}></img>
          <Link
            to={{
              pathname: `/${path}/${item.id}`,
            }}
          >
            {props.id}.{index + 1} {item.name}
          </Link>

        </Col>
        <Col span={9}>
          影片時長：{Math.floor(item.videotime / 60)}:
          {item.videotime % 60 < 10
            ? '0' + (item.videotime % 60)
            : item.videotime % 60}
        </Col>
      </Row>
      )
    } else {
      return (
        <Row key={index} style={{ margin: '1rem auto' }}>
        <Col span={15}>
          <img src={videoStart} alt="end" style={{ width: '1rem' }}></img>
          <Link
            to={{
              pathname: `/${path}/${item.id}`,
            }}
          >
            {props.id}.{index + 1} {item.name}
          </Link>
        </Col>
        <Col span={9}>
          影片時長：{Math.floor(item.videotime / 60)}:
          {item.videotime % 60 < 10
            ? '0' + (item.videotime % 60)
            : item.videotime % 60}
        </Col>
      </Row>
      )
    }
      
    
  })
  return videodom
}
export default VideoTitle
